// shared components
import Header from "./views/shared/Header";
import Footer from "./views/shared/Footer";
import ScrollToTop from "./views/shared/ScrollToTop";

// page components
import Home from "./views/Home";
import About from "./views/About";
import InStore from "./views/case-studies/InStore";

// dependencies
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <div>
      <Header />
      <ScrollToTop />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/in-store" element={<InStore />} />
        </Routes>
      </div>
      <Footer />
      <div id="blur-bg">
        <div className="blur"></div>
        <div className="blur"></div>
        <div className="blur"></div>
      </div>
    </div>
  );
}

export default App;